import React from 'react'
import _ from 'lodash'
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps";
import {SearchBox} from "react-google-maps/lib/components/places/SearchBox";
import { compose, withProps, lifecycle } from 'recompose'

/*global google:true*/
const MapWithASearchBox = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBGivnjnSrzq-vZNKBIlfhOMxyTlZb9YB0&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    lifecycle({
        componentWillMount() {
            const refs = {}

            this.setState({
                bounds: null,
                center: {
                    lat: 45.756817, lng: 21.227746
                },
                markers: [],
                onMapMounted: ref => {
                    refs.map = ref;
                },
                onIdle: () => {
                    this.setState({
                        bounds: refs.map.getBounds(),
                        center: refs.map.getCenter(),
                    })
                },
                onSearchBoxMounted: ref => {
                    refs.searchBox = ref;
                },
                onMapClick: e => {
                    const latLng = e.latLng;
                    this.setState({
                        markers: [
                            new google.maps.Marker({
                                position: latLng
                            })
                        ]
                    })
                },
                onPlacesChanged: () => {
                    const places = refs.searchBox.getPlaces();
                    const bounds = new google.maps.LatLngBounds();

                    places.forEach(place => {
                        if (place.geometry.viewport) {
                            bounds.union(place.geometry.viewport)
                        } else {
                            bounds.extend(place.geometry.location)
                        }
                    });
                    const nextMarkers = places.map(place => ({
                        position: place.geometry.location,
                    }));
                    const nextCenter = _.get(nextMarkers, '0.position', this.state.center);

                    this.setState({
                        center: nextCenter,
                        markers: nextMarkers,
                    });
                },
            })
        },
    }),
    withScriptjs,
    withGoogleMap
)(props => {

        if (props.markers[0]) {
            props.onSetMarker(props.markers[0].position);
        }

        return <GoogleMap
            ref={props.onMapMounted}
            defaultZoom={15}
            onClick={props.onMapClick}
            center={props.center}
            onIdle={props.onIdle} >
            <SearchBox
                ref={props.onSearchBoxMounted}
                bounds={props.bounds}
                controlPosition={google.maps.ControlPosition.TOP_LEFT}
                onPlacesChanged={props.onPlacesChanged} >
                <input
                    type="text"
                    placeholder="Search for a street name..."
                    style={{
                        boxSizing: `border-box`,
                        border: `1px solid transparent`,
                        width: `400px`,
                        height: `32px`,
                        marginTop: `10px`,
                        padding: `0 12px`,
                        borderRadius: `3px`,
                        boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                        fontSize: `14px`,
                        outline: `none`,
                        textOverflow: `ellipses`,
                    }}
                />
            </SearchBox>
            {props.markers.map((marker, index) =>
                <Marker key={index} position={marker.position} />
            )}
        </GoogleMap>
    }
);

export default MapWithASearchBox



// WEBPACK FOOTER //
// ./src/components/MapWithASearchBox.js